import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import CategoriesPage from './new/CategoriesPage';
import ProductsPage from './new/ProductsPage';
import BlogsPage from './new/BlogsPage';
import NewsletterForm from './components/NewsletterForm';
import LoginForm from './LoginForm';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(sessionStorage.getItem('isLoggedIn') === 'true');

  const handleLogout = () => {
    sessionStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
    window.location.href = '/';
  };

  useEffect(() => {
    const checkLogin = () => {
      setIsLoggedIn(sessionStorage.getItem('isLoggedIn') === 'true');
    };
    window.addEventListener('storage', checkLogin);
    return () => {
      window.removeEventListener('storage', checkLogin);
    };
  }, []);

  return (
    <Router>
      <div>
        {isLoggedIn && (
          <nav className='p-5 d-flex justify-content-center my-nav'>
            <Link to="/categories" className="btn btn-outline-info me-4 text-decoration-none">Categories</Link>
            <Link to="/products" className="btn btn-outline-secondary me-4 text-decoration-none">Products</Link>
            <Link to="/blogs" className="btn btn-outline-success me-4 text-decoration-none">Blogs</Link>
            <Link to="/news" className="btn btn-outline-danger me-4 text-decoration-none">NewsletterForm</Link>
            <button type="button" className="btn btn-outline-warning" onClick={handleLogout}>Logout</button>
          </nav>
        )}

        <Routes>
          <Route 
            path="/" 
            element={
              isLoggedIn 
                ? <Navigate to="/categories" /> 
                : <LoginForm setIsLoggedIn={setIsLoggedIn} />
            } 
          />
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <CategoriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blogs"
            element={
              <ProtectedRoute>
                <BlogsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/news"
            element={
              <ProtectedRoute>
                <NewsletterForm />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
